<template>
    <div>
        <card-header title="Support Tickets" icon="fa-life-ring"/>

        <card-body>
            <card-list>
                <li class="status-filters">
                    <button v-for="f in filters" :key="f.status"
                        class="filter-btn" :class="{active: selectedStatus === f.status}"
                        @click="selectStatus(f.status)">
                        {{f.label}}
                    </button>
                </li>

                <separator-list-item/>

                <support-ticket-tile v-for="ticket in tickets" :key="ticket.id" :card="card" :ticket="ticket"
                    :active="isActive(ticket.id)"
                    @click="$openCard('support-ticket', {ticketId: ticket.id}, card)"/>
            </card-list>

            <infinite-loading @infinite="loadTickets" ref="infinite">
                <div slot="no-more"></div>
                <div slot="no-results">No tickets found.</div>
            </infinite-loading>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import SupportTicketTile from "../../components/tiles/SupportTicketTile";
    import {client as http} from '@/http_client';

    export default {
        components: {SeparatorListItem, CardHeader, CardBody, CardList, SupportTicketTile},
        props: ['card', 'child', 'props'],
        data() {
            return {
                tickets: [],
                selectedStatus: null,
                paging: {total: 0, start: 0},
                filters: [
                    {status: null, label: 'All'},
                    {status: 'open', label: 'Open'},
                    {status: 'assigned', label: 'Assigned'},
                    {status: 'on_hold', label: 'On Hold'},
                    {status: 'closed', label: 'Closed'}
                ]
            }
        },
        methods: {
            loadTickets($state) {
                let url = 'support/tickets?user_id=' + this.props.userId + '&page=' + Math.floor(this.paging.start / 50) + '&limit=50';
                if (this.selectedStatus) url += '&status=' + this.selectedStatus;

                http.get(url, {force: true}).then(response => {
                    let data = response.data;
                    let items = data.tickets || [];
                    this.tickets.push(...items);
                    this.paging.total = data.total || 0;
                    this.paging.start += items.length;

                    this.$emit('loading', false);
                    if ($state) $state.loaded();
                    if ($state && this.tickets.length >= this.paging.total) {
                        $state.complete();
                    }
                }).catch(err => {
                    console.log(err);
                    this.$emit('loading', false);
                    if ($state) $state.complete();
                });
            },
            selectStatus(status) {
                this.selectedStatus = status;
                this.reset();
            },
            reset() {
                this.tickets = [];
                this.paging = {total: 0, start: 0};
                this.$emit('loading', true);
                if (this.$refs.infinite) {
                    this.$refs.infinite.stateChanger.reset();
                }
            },
            isActive(ticketId) {
                return this.child && this.child.definition.component === 'support-ticket' && parseInt(this.child.props.ticketId) === ticketId;
            },
        },
        watch: {
            'props.userId': function() {
                this.reset();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .status-filters {
        display: flex;
        gap: 6px;
        padding: 10px 10px;
        background-color: #fafafa;
        list-style: none;

        .filter-btn {
            flex: 1;
            padding: 5px 8px;
            font-size: 0.75rem;
            font-weight: 600;
            border: 1px solid #ddd;
            border-radius: 4px;
            background: #fff;
            color: #555;
            cursor: pointer;
            text-align: center;
            white-space: nowrap;

            &:hover {
                background: #f0f0f0;
            }

            &.active {
                background: #28547F;
                color: #fff;
                border-color: #28547F;
            }
        }
    }
</style>
